import AlgoliaData from '@module/Algolia/resources/js/search/interfaces/AlgoliaData';
import StoreData from '../interfaces/StoreData';
import {
  transformProduct as baseTransformProduct,
  transformStore as baseTransformStore,
} from '@module/Algolia/resources/js/search/transformers';
import { getData } from '@module/Algolia/resources/js/search/helpers';
import ProductData from '@maison/search/interfaces/ProductData';

export const transformProduct = (data: AlgoliaData): ProductData => ({
  ...baseTransformProduct(data),
  sliderImages: getData(data.sliderImages, []),
});

export const transformStore = (data: AlgoliaData): StoreData => ({
  ...baseTransformStore(data),
  storeType: getData(data.storeType, ''),
  searchImg: getData(data.imageCard, null),
});
